<template>
  <div id="app" style="background-color: #fff;">
    <router-view></router-view>
  </div>
</template>
<script>
  import {mapActions} from 'vuex'

  export default {
    methods: {
      ...mapActions([
        'api_get_login_user',
        'api_get_login_user_no_logout',
        'api_get_menu_list'
      ])
    },
    mounted() {
    }
  }
</script>
<style>
  #app section {
    overflow: hidden;
  }

  #app section .mtd-main::-webkit-scrollbar {
    width: 0 !important
  }

  #app section .mtd-main {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }
</style>
